import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";
import { getStockByIdAndBranch } from "../../../../../Stock/StockAnalysis/Redux/api";

// get saleReturn
export const getSaleReturn = createAsyncThunk("saleReturn/getSaleReturn", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.getSaleReturn({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get all saleReturn
export const getAllSaleReturn = createAsyncThunk("saleReturn/getAllSaleReturn", async (_, { rejectWithValue }) => {
  try {
    const { data } = await API.getAllSaleReturn();
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get previous
export const getPrevious = createAsyncThunk("saleReturn/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("saleReturn/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk(
  "saleReturn/getParticularPage",
  async (params, { rejectWithValue }) => {
    const { number, rowsPerPage, search } = params;
    try {
      const { data } = await API.getPageSaleReturn({ number, rowsPerPage: rowsPerPage, search });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get item by id
export const getSaleReturnById = createAsyncThunk("saleReturn/getSaleReturnById", async (id, { rejectWithValue }) => {
  try {
    const { data } = await API.getSaleReturnById(id);
    if (data?.data?.salesOrderMain?.saleOrderDetails?.length > 0) {
      // get stock by id and branch
      const updatedDetailsPromises = data?.data?.salesOrderMain?.saleOrderDetails?.map(async (detail) => {
        const { data: stockData } = await getStockByIdAndBranch(detail?.product?.id, data?.data.branch); // getStockByIdAndBranch

        if (stockData.data?.length > 0) {
          return {
            ...detail,
            // availableStock stock from stockData
            availableStock: stockData.data[0]?.closingStock || "",
          };
        } else {
          return {
            ...detail,
            availableStock: 0,
          };
        }
      });

      const updatedDetails = await Promise.all(updatedDetailsPromises);
      return {
        ...data,
        data: { ...data.data, salesOrderMain: { ...data.data.salesOrderMain, saleOrderDetails: updatedDetails } },
      };
    } else {
      return data;
    }
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

export const getSaleReturnAdditionalChargeList = createAsyncThunk(
  "saleReturn/getSaleReturnAdditionalChargeList",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await API.getSaleReturnAdditionalChargeList();
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

export const getSaleInvoiceDetail = createAsyncThunk(
  "saleReturn/getSaleInvoiceDetail",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.getSaleInvoiceDetail(id);

      if (data?.data.saleInvoiceDetails?.length > 0) {
        // get stock by id and branch
        const updatedDetailsPromises = data.data?.saleInvoiceDetails.map(async (detail) => {
          const { data: stockData } = await getStockByIdAndBranch(detail?.product?.id, data?.data.branch?.id); // getStockByIdAndBranch

          if (stockData.data?.length > 0) {
            return {
              ...detail,
              // availableStock stock from stockData
              availableStock: stockData.data[0]?.closingStock || "",
            };
          } else {
            return {
              ...detail,
              availableStock: 0,
            };
          }
        });

        const updatedDetails = await Promise.all(updatedDetailsPromises);
        return { ...data, data: { ...data.data, saleInvoiceDetails: updatedDetails } };
      } else {
        return data;
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// create saleReturn
export const createSaleReturn = createAsyncThunk(
  "saleReturn/createSaleReturn",
  async (createData, { rejectWithValue }) => {
    const {
      salesOrderInvoice,
      branch,
      partyAccount,
      refundAmount,
      vatAmount,
      remarks,
      salesOrderReturnDetails,
      saleOrderReturnAdditionalChargeCost,
      saleOrderReturnMainPartyDetails,
      saleOrderReturnMainVehicleDetail,
    } = createData;
    try {
      const body = JSON.stringify({
        salesOrderInvoice,
        branch,
        partyAccount,
        refundAmount,
        vatAmount,
        salesOrderReturnDetails,
        saleOrderReturnAdditionalChargeCost,
        saleOrderReturnMainPartyDetails,
        saleOrderReturnMainVehicleDetail,
        remarks,
      });

      const { data } = await API.createSaleReturn(body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const updateSaleReturn = createAsyncThunk("saleReturn/updateSaleReturn", async (params, { rejectWithValue }) => {
  const { id, values } = params;
  const {
    salesOrder,
    indentNo,
    isFromHo,
    requiredDateAd,
    voucherDate,
    branch,
    status,
    documentsAttach,
    // refVoucher,
    saleReturnDetails,
    saleOrderReturnMainPartyDetails,
    saleOrderReturnMainVehicleDetail,
  } = values;
  try {
    const body = JSON.stringify({
      salesOrder,
      indentNo,
      isFromHo,
      requiredDateAd,
      branch,
      status,
      voucherDate,
      // refVoucher,
      saleReturnDetails,
      saleOrderReturnMainPartyDetails,
      saleOrderReturnMainVehicleDetail,
    });
    const { data } = await API.updateSaleReturn(id, body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});
export const approveSaleReturn = createAsyncThunk("saleReturn/approveSaleReturn", async (id, { rejectWithValue }) => {
  try {
    const { data } = await API.approveSaleReturn(id);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});
export const cancelSaleReturn = createAsyncThunk("saleReturn/cancelSaleReturn", async (id, { rejectWithValue }) => {
  try {
    const { data } = await API.cancelSaleReturn(id);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});
// handle search
export const handleSearch = createAsyncThunk(
  "saleReturn/handleSearch",
  async ({ rowsPerPage, search, sortOrder, pageNo }, { rejectWithValue }) => {
    try {
      const { data } = await API.handleSearch({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
